import React, { useEffect } from 'react';
import BidDetailsPrice from "./bidDetailsPrice"
import API from "../../API";
import axios from "axios";
const BidDetailsPriceContainer = (props) => {
    const { project_id, provider_project_id, project_number, from } = props.match.params;
    const [hireData, setHireData] = React.useState(null);
    const [hireLoading, setHireLoading] = React.useState(false);
    useEffect(() => {
        console.log('asdsadas');
        
        const fetchHireDetails = async () => {
            setHireLoading(true);
            try {
                const apiUrl = `${API.baseURL}/v2/customers/projects/${project_id}/initiate_hire?project_number=${project_number}`;
                const response = await axios.get(apiUrl, API.options);
                setHireData(response.data.response);
                console.log(response.data.response, "response.data.response");
            } catch (error) {
                console.error(error);
            }
            setHireLoading(false);
        };

        fetchHireDetails();
    }, [project_id, project_number]);
    return (
        <BidDetailsPrice
            from={from}
            project_id={project_id}
            provider_project_id={provider_project_id}
            // project_number={project_number}
            bidDetailsLoading={hireLoading}
            hireData={hireData}
            history={props.history}
        />
    );
}

export default BidDetailsPriceContainer;